export const getSchema = (schema) => {
  if (Array.isArray(schema)) {
    return schema[0];
  }
  return schema;
};

export const getType = (schema) => getSchema(schema)._key;
